import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetContactAction } from '../../../../ts/ServerApi/types/actionNames';
import { setContactAction } from '../../../actions/spaces/SetContactAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SetContactAction: IEntityAction<IContentInfo, ISetContactAction> = {
  name: EntityActionNames.SetContact,
  translateName: Messages.changeContact_action,
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.externalContentContactEnabled,
  isClickable: (availableActions: ISetContactAction) => !!(availableActions && availableActions.setContact),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setContact was called without exactly one item');
    }

    return setContactAction(items[0]);
  }
};
